/** 서버가 받는 카테고리 접두 길이 — `[0,2)` 국가 · `[2,3)` 학교급 · `[3,5)` 학년 · `[5,7)` 과목 */
const CATEGORY_PREFIX_LENGTH = 7;

/**
 * 문제 은행 노출 판정. 규칙은 없다 — 서버 build-info 가 내린 "노출 중인 은행의 카테고리 접두"
 * 목록에 앞 7자리가 있는지만 본다. 국가(유저 국가로 스코프를 거른다)와 어드민 노출 토글은
 * 서버(`QuizBankExposureService`)가 끝내므로, 과목을 더하거나 끄는 배포에 클라가 따라갈 필요가 없다.
 *
 * 예전에 두 축(유저 국가 + 카테고리 국가)으로 막던 경로도 그대로 막힌다.
 * - 유저 비한국 + 카테고리 `10…`(`lastQuizSetCreationInfo` 의 CREATE 기본값): 서버가 빈 목록을 내린다.
 * - 유저 한국 + 비한국 카테고리(복제·수정이 시드한 원본 세트 id): 한국 접두 목록에 없다.
 */
export const isQuizBankSupported = (
  categoryTreeId: string | undefined,
  { exposedCategoryPrefixes }: { exposedCategoryPrefixes: readonly string[] },
): boolean => {
  if (!categoryTreeId || categoryTreeId.length < CATEGORY_PREFIX_LENGTH) {
    return false;
  }
  return exposedCategoryPrefixes.includes(
    categoryTreeId.slice(0, CATEGORY_PREFIX_LENGTH),
  );
};

/** 서버가 받는 7자리로 자른다. 폼의 `subSubject`(9자리)가 와도 안전하다. */
export const toQuizBankCategoryTreeId = (categoryTreeId: string) =>
  categoryTreeId.slice(0, CATEGORY_PREFIX_LENGTH);

/** 학년 코드(`'01'`~`'06'`). 앞단에서 고른 학년이 미리 적용된 필터가 된다. */
export const toQuizBankGradeCode = (categoryTreeId: string) =>
  categoryTreeId.slice(3, 5);

const ALL_GRADES_CODE = '99';

/**
 * 진입 시 radio 초기값. 전학년(`99`)은 서버가 받지 않으므로 `null`(전체)로 바꾼다 —
 * 그대로 보내면 200 + 빈 목록이라 원인이 드러나지 않는다.
 */
export const toQuizBankInitialGradeId = (
  categoryTreeId: string,
): string | null => {
  const grade = toQuizBankGradeCode(categoryTreeId);
  return grade === ALL_GRADES_CODE ? null : grade;
};
